import axios from "axios";
import { del, get, post, patch,  put } from "./internship_services_api_helper";
import * as url from "./internship_services_url_helper";





// Get features
export const getInternshipServices = () => get(url.GET_INTERNSHIP_SERVICES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewInternshipService = internshipService => post(url.ADD_NEW_INTERNSHIP_SERVICE, internshipService);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateInternshipService = internshipService => patch(`${url.UPDATE_INTERNSHIP_SERVICE}/${internshipService.id}`,  internshipService);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteInternshipService = internshipService => del(`${url.DELETE_INTERNSHIP_SERVICE}/${internshipService.id}`);







export {
  //getLoggedInUser,
  
  
};
